import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import {
    ModalAdapter,
    ModalContainer,
    ModalHeader,
} from "@malirang/front-share";
import { DocumentSelectTicket } from "./document-select-ticket";

@Component({
    selector: "app-document-select-ticket-modal",
    template: `
        <section modalContainer>
            <app-modal-header header>서비스 선택</app-modal-header>
            <app-document-select-ticket class="p-4" />
        </section>
    `,
    imports: [CommonModule, ModalHeader, ModalContainer, DocumentSelectTicket],
})
export class DocumentSelectTicketModal extends ModalAdapter {}
